<template>
  <input
    type="text"
    class="timepicker form_global max_width_200p"
    :class="className"
    :value="input"
    @input="$emit('update:input', $event.target.value)"
    placeholder="HH:mm"
    :disabled="disabled"
  />
</template>

<script>
import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui-timepicker-addon';
import 'jquery-ui-timepicker-addon/dist/jquery-ui-timepicker-addon.css';

export default {
  props: {
    input: String, // Value to bind
    className: String, // Optional class for the input
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:input', 'onSelect'],
  watch: {
    input(value) {
      $(this.$el).timepicker('setTime', value); // Set the time when the bound value changes
    },
  },
  mounted() {
    const self = this;
    $(this.$el).timepicker({
      timeFormat: 'HH:mm',
      onSelect: function (time) {
        self.$emit('update:input', time); // Emit the new time
        self.$emit('onSelect', time);
      },
    });

    // Initialize with the provided time
    $(this.$el).timepicker('setTime', self.input);
  },
  beforeUnmount() {
    // Clean up the timepicker to avoid memory leaks
    $(this.$el).timepicker('destroy');
  },
};
</script>

<style scoped>
/* Optional custom styles */
.timepicker {
  padding: 5px;
  font-size: 14px;
}
</style>
